import { render } from "./ThemesAdd.vue?vue&type=template&id=f3c62a50"
import script from "./ThemesAdd.vue?vue&type=script&lang=js"
export * from "./ThemesAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__